// extracted by mini-css-extract-plugin
export default {"container":"slider_container__Mm43D","slider":"slider_slider__PC7aZ","input":"slider_input__HcMu6"};